// extracted by mini-css-extract-plugin
module.exports = {"responsibleGaming":"_9b91764","regulatoryText":"_f4d3b4d","regulatoryIcon":"_ff5fafd","regulatoryIconText":"_6f6d6e6"};